import { gql } from '@apollo/client';

export const UNARCHIVE_PERSONAL_TRANSACTIONS = gql`
  mutation updateClassificationStateForJournalEntries(
    $input: UpdateClassificationStateForJournalEntries!
  ) {
    updateClassificationStateForJournalEntries(input: $input) {
      ... on UpdateClassificationStateForJournalEntriesResponse {
        numberOfJournalEntriesUpdated
      }
    }
  }
`;

export const CLASSIFY_PB_TRANSACTIONS = gql`
  mutation classifyTransactions(
    $input: ClassifyPersonalBusinessDataEntriesInput!
    $skipDataEntries: Boolean!
  ) {
    classifyPersonalBusinessDataEntries(input: $input) {
      numberOfDataEntriesClassified
      dataEntries @skip(if: $skipDataEntries) {
        id
        amount
        ledgerAccount {
          id
          name
        }
        journalEntry {
          vendorName
          dateOfTransaction
          id
          classification {
            id
            value
            state
          }
        }
      }
    }
  }
`;

export const CONFIRM_PERSONAL_BUSINESS_CLASSIFICATIONS = gql`
  mutation confirmClassification($input: ConfirmPersonalBusinessClassificationInput!) {
    confirmPersonalBusinessClassifications(input: $input) {
      numberOfDataEntriesConfirmed
    }
  }
`;
